<template>
  <footer>
    <div>
      Baka Solutions, 2021
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style>
footer > div {
  margin: var(--padding-topsides) var(--padding-sides);
}
</style>